import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import ShopHeader from "../components/ShopHeader";
import SingleProduct from "../components/SingleProduct";
import ProductsData from "../components/ProductsData";

export default function AllProducts(props) {
  window.scrollTo(0, 0);

  const [searchItem, setSearchItem] = useState("");

  const searchHandler = (event) => {
    setSearchItem(event.target.value);
  };

  const searchResult = (props.productCategory === "general" ? (
    ProductsData.filter((singleProduct) => {
      return (singleProduct.pTitle.toLowerCase().includes(searchItem.toLowerCase()));
    })
  ) : (
    ProductsData.filter((singleProduct) => {
      return ((singleProduct.pTitle.toLowerCase().includes(searchItem.toLowerCase())) && (singleProduct.pCategory.toLowerCase().includes(props.productCategory.toLowerCase())));
    })
  ));

  useEffect(() => {
    localStorage.setItem("searchResult", JSON.stringify(searchResult))
  }, [searchResult]);

  return (
    <>
      <ShopHeader searchValue={searchItem} searchEventHandler={searchHandler} />

      {/* Products Start */}
      <div className="container-fluid home-container mb-4">
        <div className="row pt-5 pt-md-3 mt-4 mt-md-0 shop-products justify-content-center gap-0">
          {searchResult.length > 0 ? (
            searchResult.map((singleProduct) => {
              return (
                <SingleProduct
                  key={singleProduct.pid}
                  productImg={singleProduct.pImg}
                  productCategory={singleProduct.pCategory}
                  productTitle={singleProduct.pTitle}
                  productPrice={singleProduct.pPrice}
                  product={singleProduct}
                  mb="5"
                />
              );
            })
          ) : (
            <p className="text-center fs-4">Sorry, No match found!!!</p>
          )}
          { }
        </div>
      </div>
      {/* Products End */}
      <Footer />
      <div className="m-0 mb-5 p-0 pb-4 d-block d-md-none"></div>
    </>
  );
}
